'use strict';

angular.module('user')
    .controller('ChangePasswordFormController', ['$q', 'AccountManager', 'ShareCrfApiErrorCodes', function($q, AccountManager, ShareCrfApiErrorCodes) {
        var vm = this;

        vm.$onInit = function() {
            vm.data = {};

            vm.error = false;
            vm.submitted = false;
            vm.running = false;

            /**
             * Submit form
             *
             * @param {Form}
             *
             * @return {Promise}
             */
            vm.submit = function(form) {
                vm.submitted = true;
                var promise = $q.resolve();

                if (form.$valid) {
                    vm.running = true;

                    promise = AccountManager.changePassword({
                        userId: vm.recoveryData.userId,
                        hash: vm.recoveryData.recoverHash,
                        password: vm.data.password,
                    })
                        .then(function() {
                            vm.running = false;
                            return vm.onSubmit();
                        })
                        .catch(function(error) {
                            vm.running = false;
                            vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                        });
                }

                return promise;
            };
        };

        vm.checkPassword = function(value) {
            return vm.data.password === value;
        };
    }]);
